import IconMobilePhone, {
	IconMobilePhoneProps as _IconMobilePhoneProps,
} from './IconMobilePhone';

export { IconMobilePhone };
export type IconMobilePhoneProps = _IconMobilePhoneProps;
